import React from 'react';
import ReactDOM from 'react-dom/client';
import { message } from 'antd';
import { assemblyEstimateService } from '@/services/assemblyEstimate.service';
import { PrintableAssemblyEstimate } from '@/components/estimation/PrintableAssemblyEstimate';
import type { AssemblyEstimatePrintDetail } from '@/utils/assemblyEstimatePrint';

function unwrapDetail(raw: unknown): AssemblyEstimatePrintDetail {
  if (raw && typeof raw === 'object' && 'data' in raw && (raw as { data?: AssemblyEstimatePrintDetail }).data) {
    return (raw as { data: AssemblyEstimatePrintDetail }).data;
  }
  return raw as AssemblyEstimatePrintDetail;
}

/** Fetch assembly estimate detail and open paginated print preview. */
export async function openAssemblyEstimatePrint(estimateId: string): Promise<void> {
  try {
    const detail = unwrapDetail(await assemblyEstimateService.get(estimateId));
    if (!detail?.estimate?.id && !detail?.estimate?.estimate_number) {
      message.error('Assembly estimate not found');
      return;
    }

    const mainContent = document.querySelector('.ant-layout-content') as HTMLElement | null;
    const printContainer = document.createElement('div');
    printContainer.id = 'print-container';
    document.body.appendChild(printContainer);
    if (mainContent) mainContent.style.display = 'none';

    let root: ReactDOM.Root | null = null;
    const cleanup = () => {
      root?.unmount();
      if (printContainer.parentNode) document.body.removeChild(printContainer);
      if (mainContent) mainContent.style.display = '';
      window.removeEventListener('afterprint', cleanup);
    };

    root = ReactDOM.createRoot(printContainer);
    root.render(<PrintableAssemblyEstimate detail={detail} onClose={cleanup} />);
    window.addEventListener('afterprint', cleanup);
  } catch (e: unknown) {
    const err = e as { response?: { data?: { message?: string } }; message?: string };
    message.error(err?.response?.data?.message || err?.message || 'Failed to open assembly estimate print');
  }
}
